import { Box, Card } from "@mui/material";
import Calendar from "components/calendar/Calendar";
import { CalendarProvider } from "components/calendar/context/CalendarContext";
import useTitle from "hooks/useTitle";
import { FC } from "react";
import ScheduleFilter from "./scheduleFilter/ScheduleFilter";
import ScheduleStatus from "./scheduleFilter/ScheduleStatus";

const ScheduleView: FC = () => {
  useTitle("Agenda");

  return (
    <CalendarProvider>
      <Box
        pt={2}
        pb={4}
        display="flex"
        flexDirection="column"
        gap={1.2}
        minWidth={0}
      >
        <Card sx={{ p: { xs: 1.25, md: 1.5 }, minWidth: 0 }}>
          <ScheduleStatus />
        </Card>
        <Card sx={{ p: { xs: 1.75, md: 2.25 }, minWidth: 0 }}>
          <ScheduleFilter />
        </Card>
        <Card sx={{ minWidth: 0 }}>
          <Calendar />
        </Card>
      </Box>
    </CalendarProvider>
  );
};

export default ScheduleView;
